import { useFormik } from 'formik';
import { initialValues, validationSchema } from './formData';
import { ISelect, ParamEnum } from '../../../../../../shared/types/shared';
import { useEffect, useState } from 'react';
import { PqrData } from '../../../../../../shared/types/modules/pqr';
import { PqrDataProps } from './props';
import { asyncGetParams } from '../../../../../../services/param.service';

export const usePqrData = ({
    data,
    onChangeData,
    onChangeFormik,
}: PqrDataProps) => {
    const [branches, setBranches] = useState<ISelect[]>([]);
    const [receptionChannels, setReceptionChannels] = useState<ISelect[]>([]);
    const [types, setTypes] = useState<ISelect[]>([]);
    const [halfs, setHalfs] = useState<ISelect[]>([]);
    const [subtypeDps, setSubtypeDps] = useState<ISelect[]>([]);
    const [procedures, setProcedures] = useState<ISelect[]>([]);
    const [extra, setExtra] = useState<string | undefined>('');
    const [name, setName] = useState<string | undefined>('');
    const [isOpen, setIsOpen] = useState<boolean>(false);

    const onSubmit = (data: PqrData) => {
        if (onChangeData) onChangeData(data || {});
    };

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit,
    });

    useEffect(() => {
        if (onChangeFormik) onChangeFormik(formik);
    }, [formik.values, formik.errors]);

    useEffect(() => {
        formik?.setFieldValue('branch', data?.branch || '');
        formik?.setFieldValue('receptionChannel', data?.receptionChannel || '');
        formik?.setFieldValue('type', data?.type || '');
        formik?.setFieldValue('half', data?.half || '');
        formik?.setFieldValue('subtypeDp', data?.subtypeDp || '');
        formik?.setFieldValue('procedure', data?.procedure || '');
    }, [data]);

    useEffect(() => {
        if (Boolean(formik.values.type)) {
            asyncGetParams(
                ParamEnum.PQR_HALF,
                undefined,
                formik.values.type
            ).then((items) => {
                setHalfs(items);
                const extraParam =
                    types?.filter(
                        (param) => param.id === formik.values.type
                    )[0] || undefined;
                setExtra(extraParam?.extra);
                setName(extraParam?.name);
                setIsOpen(true);
            });
        } else {
            setIsOpen(false);
        }
        if (!data || !Boolean(data.half)) {
            formik?.setFieldValue('half', '');
            formik?.setFieldValue('subtypeDp', '');
        }
    }, [formik.values.type, types]);

    useEffect(() => {
        if (Boolean(formik.values.half)) {
            asyncGetParams(
                ParamEnum.PQR_SUBTYPE_DP,
                undefined,
                formik.values.half
            ).then((items) => setSubtypeDps(items));
        }
        if (!data || !Boolean(data.subtypeDp))
            formik?.setFieldValue('subtypeDp', '');
    }, [formik.values.half]);

    useEffect(() => {
        asyncGetParams(ParamEnum.PQR_BRANCH).then((items) =>
            setBranches(items)
        );
        asyncGetParams(ParamEnum.PQR_RECEPTION_CHANNEL).then((items) =>
            setReceptionChannels(items)
        );
        asyncGetParams(ParamEnum.PQR_TYPE).then((items) => setTypes(items));
        asyncGetParams(ParamEnum.PQR_PROCEDURE).then((items) =>
            setProcedures(items)
        );
    }, []);

    const handleClose = () => {
        setIsOpen(false);
        setExtra('');
    };

    return {
        formik,
        branches,
        receptionChannels,
        types,
        halfs,
        subtypeDps,
        procedures,
        isOpen,
        name,
        extra,
        handleClose,
    };
};
